/* eslint-disable no-undef */

export default () => {
  return window.navigator.userAgent === 'ReactSnap'
}
